import React, { useEffect, useState } from "react";
import {
  fetchAllPayments,
  fetchPaymentSummary,
} from "../../services/paymentService";

import PaymentTable from "./PaymentTable";
import "./paymentDashboard.css";

const isDev = process.env.NODE_ENV === "development";

const PaymentDashboard = () => {

  const [payments, setPayments] = useState([]);
  const [summary, setSummary] = useState({});
  const [loading, setLoading] = useState(true);

  const devLog = (...args) => {
    if (isDev) {
      console.log("[PaymentDashboard]", ...args);
    }
  };

  useEffect(() => {

    devLog("Component mounted");

    loadPayments();
    loadSummary();

  }, []);

  const loadPayments = async () => {

    try {

      devLog("loadPayments() started");

      const res = await fetchAllPayments();

      devLog("Payments API FULL response:", res);

      devLog("Payments API data:", res.data);

      if (res.data && Array.isArray(res.data.content)) {

        setPayments(res.data.content);

        devLog(
          "Payments state updated. Count:",
          res.data.content.length
        );

      } else {

        devLog("Unexpected payments response format:", res.data);

        setPayments([]);

      }

    } catch (err) {

      console.error("Failed to load payments", err);

      devLog("Error loading payments:", err);

    } finally {

      setLoading(false);

      devLog("loadPayments() finished. Loading=false");

    }
  };

  const loadSummary = async () => {

    try {

      devLog("loadSummary() started");

      const res = await fetchPaymentSummary();

      devLog("Summary API FULL response:", res);

      devLog("Summary API data:", res.data);

      setSummary(res.data);

      devLog("Summary state updated:", res.data);

    } catch (err) {

      console.error("Failed to load summary", err);

      devLog("Error loading summary:", err);

    }
  };

  devLog("Render state:", {
    paymentsCount: payments.length,
    summary,
    loading
  });

  if (loading) {

    devLog("Rendering loading state");

    return <div className="loading">Loading payments...</div>;

  }

  devLog("Rendering dashboard");

  return (

    <div className="payment-dashboard">

      <h2>Payment Dashboard</h2>

      <div className="summary-container">

        <div className="summary-card">
          <div className="summary-title">Total Revenue</div>
          <div className="summary-value">
            ₹{(summary.totalRevenue/ 100) || 0}
          </div>
        </div>

        <div className="summary-card">
          <div className="summary-title">Total Payments</div>
          <div className="summary-value">
            {summary.totalPayments || 0}
          </div>
        </div>

        <div className="summary-card success">
          <div className="summary-title">Successful</div>
          <div className="summary-value">
            {summary.successfulPayments || 0}
          </div>
        </div>

        <div className="summary-card failed">
          <div className="summary-title">Failed</div>
          <div className="summary-value">
            {summary.failedPayments || 0}
          </div>
        </div>

      </div>

      <PaymentTable payments={payments} />

    </div>

  );

};

export default PaymentDashboard;
